import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
*查询L1统计图形的数据
 * @param params
 */
export function getEnergyFeeLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/level1',
        method: 'get',
        params
    })
}

/**
*查询L1列表的数据
 * @param params
 */
export function listLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/list',
        method: 'get',
        params
    })
}

/**
*查询l2电力统计图形的数据
 * @param params
 */
export function getPowerLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/power/level2',
        method: 'get',
        params
    })
}

/**
*查询l2电力列表的数据
 * @param params
 */
export function listPower(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/power/list',
        method: 'get',
        params
    })
}

/**
*查询L2水统计图形的数据
 * @param params
 */
export function getWaterLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/water/level2',
        method: 'get',
        params
    })
}

/**
*查询L2水列表的数据
 * @param params
 */
export function listWater(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/water/list',
        method: 'get',
        params
    })
}

/**
*天然气
 * @param params
 */
export function getGasLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/gas/level2',
        method: 'get',
        params
    })
}

/**
*天然气
 * @param params
 */
export function listGas(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/gas/list',
        method: 'get',
        params
    })
}

/**
*热力
 * @param params
 */
export function getHotLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/hot/level2',
        method: 'get',
        params
    })
}

/**
*热力
 * @param params
 */
export function listHot(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/hot/list',
        method: 'get',
        params
    })
}

/**
*其他
 * @param params
 */
export function getOthersLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/others/level2',
        method: 'get',
        params
    })
}

/**
*其他
 * @param params
 */
export function listOthers(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/others/list',
        method: 'get',
        params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function getEnergyPriceList(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/input/list',
        method: 'get',
        params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function updateEnergyPrice(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/energyfee/input/input',
        method: 'post',
        data: params
    })
}
/**
* 导出excel
* @param params
*/
export function exportQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/energyfee/export`,
      method: 'post',
      data: params
    })
  }
 /**
 * 导出excel
 * @param params
 */
 export function exportPowerQuery(params) {
     return request({
       url: envInfo.bgApp.cameraPath + `/camera/energyfee/export/power`,
       method: 'post',
       data: params
     })
   }
   export function exportWaterQuery(params) {
     return request({
       url: envInfo.bgApp.cameraPath + `/camera/energyfee/export/water`,
       method: 'post',
       data: params
     })
   }
   export function exportGasQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/energyfee/export/gas`,
      method: 'post',
      data: params
    })
  }
  export function exportHotQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/energyfee/export/hot`,
      method: 'post',
      data: params
    })
  }
  export function exportOthersQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/energyfee/export/others`,
      method: 'post',
      data: params
    })
  }